<template>
    <div>
        <v-layout row justify-center>
            <v-dialog v-model="mustShowScoringPopup" content-class="border-color-invisible height-90-vh"  persistent :max-width="dialogMaxWidth" class="popup-scoring" id="close-popup">
                <v-card class="popup-scoring show-scoring-popup" v-if="scoringPopupData">
                    <v-card-title v-if="getDecisionItemColor(scoringPopupData.decisions.decisionItem1)" class=" color-on-primary-text" v-bind:style="{'background-color': getDecisionItemColor(scoringPopupData.decisions.decisionItem1) }">
                        <span class="font-weight-regular">{{text('api.assessment.headline.assessment.outcome')}}</span>
                        <div @click="hideScoringPopup()" class="cursor-pointer popup-scoring-close-icon">
                            <close-icon />
                        </div>
                    </v-card-title>
                    <v-card-title v-else class="color-on-primary-text bg-color-primary">
                        <span class="font-weight-regular">{{text('api.assessment.headline.assessment.outcome')}}</span>
                        <div @click="hideScoringPopup()" class="cursor-pointer popup-scoring-close-icon">
                            <close-icon />
                        </div>
                    </v-card-title>
                    <v-card-text class="elevation-bg-color" ref="vCardPopupScoring">
                        <div>

                            <div v-if="scoringPopupData.decisions">

                                <h3 style="margin-bottom: 24px">{{text('db.product.PROD_SCORING')}}</h3>

                                <table class="assessment-content-table" role="presentation">
                                    <tr>
                                        <td>
                                            <h3 class="headline-decision-h3">{{text('api.assessment.headline.di1')}}</h3>
                                            <table :id="((scoringPopupData.decisions.decisionItem1.code) ? ('TAO_DI1_' + scoringPopupData.decisions.decisionItem1.code) : null)" role="presentation">
                                                <tr>
                                                    <td v-if="scoringPopupData.decisions.decisionItem1.icon">
                                                        <div
                                                             v-html="scoringPopupData.decisions.decisionItem1.icon"
                                                             :id="((scoringPopupData.decisions.decisionItem1.code) ? ('TAO_DI1_ICON_' + scoringPopupData.decisions.decisionItem1.code) : null)"
                                                             class="decision-item-item-svg"
                                                        >
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <h4 class="decision-headline"
                                                            v-html="scoringPopupData.decisions.decisionItem1.headline"
                                                            :id="((scoringPopupData.decisions.decisionItem1.code) ? ('TAO_DI1_HEADLINE_' + scoringPopupData.decisions.decisionItem1.code) : null)"
                                                            v-bind:style="{'color': getDecisionItemColor(scoringPopupData.decisions.decisionItem1) }"
                                                        ></h4>
                                                        <p  class="decision-text color-body"
                                                            v-html="scoringPopupData.decisions.decisionItem1.text"
                                                            :id="((scoringPopupData.decisions.decisionItem1.code) ? ('TAO_DI1_TEXT_' + scoringPopupData.decisions.decisionItem1.code) : null)"
                                                        >
                                                        </p>

                                                    </td>
                                                </tr>
                                            </table>
                                            <br style="height: 24px;"/>

                                            <h3 v-if="scoringPopupData.decisions.decisionItems2 != null && scoringPopupData.decisions.decisionItems2.length > 0" class="headline-decision-h3">{{text('api.assessment.headline.di2')}}</h3>

                                            <div v-for="decisionItem2 in scoringPopupData.decisions.decisionItems2">

                                                <table v-if="!decisionItem2.target" :id="((decisionItem2.code) ? ('TAO_DI2_NO_TARGET_' + decisionItem2.code) : null)" role="presentation">
                                                    <tr>

                                                        <td>
                                                            <h4 class="decision-headline"
                                                                v-html="decisionItem2.headline"
                                                                :id="((decisionItem2.code) ? ('TAO_DI2_HEADLINE_NO_TARGET_' + decisionItem2.code) : null)"
                                                                v-bind:style="{'color': getDecisionItemColor(decisionItem2) }"
                                                            >
                                                            </h4>
                                                            <p class="decision-text"
                                                               :id="((decisionItem2.code) ? ('TAO_DI2_TEXT_NO_TARGET_' + decisionItem2.code) : null)"
                                                               v-html="decisionItem2.text"
                                                            ></p>
                                                        </td>
                                                    </tr>
                                                </table>

                                                <table v-else :id="((decisionItem2.code) ? ('TAO_DI2_' + decisionItem2.code) : null)" role="presentation">
                                                    <tr>
                                                        <td>
                                                            <WarningIcon alt="medicine logo"
                                                                 class="ambulance-scoring scoring-page" width="28" height="28">
                                                            </WarningIcon>
                                                        </td>
                                                        <td>
                                                            <h4  class="decision-headline"
                                                                 v-html="decisionItem2.headline"
                                                                 :id="((decisionItem2.code) ? ('TAO_DI2_HEADLINE' + decisionItem2.code) : null)"
                                                                 v-bind:style="{'color': getDecisionItemColor(decisionItem2) }">
                                                            </h4>
                                                            <p class="decision-text"
                                                               :id="((decisionItem2.code) ? ('TAO_DI2_TEXT_' + decisionItem2.code) : null)"
                                                               v-html="decisionItem2.text"
                                                            ></p>
                                                        </td>
                                                    </tr>

                                                </table>

                                            </div>

                                            <br style="height: 24px;"/>

                                            <div v-if="scoringPopupData.decisions.decisionItems3 && scoringPopupData.decisions.decisionItems3.length > 0">
                                                <h3 class="headline-decision-h3">{{text('api.assessment.headline.di3')}}</h3>
                                                <div v-if="scoringPopupData.decisions.decisionItems3Recommended.length > 0" class="decision-item-header">
                                                    {{ text('api.assessment.headline.di3.recommended') }}
                                                </div>
                                                <div v-for="decisionItem3 in scoringPopupData.decisions.decisionItems3Recommended"
                                                     :id="((decisionItem3.code) ? ('TAO_DI3_REC_' + decisionItem3.code) : null)"
                                                     class="padding-left-s"
                                                >
                                                    <table role="presentation">
                                                        <tr>
                                                            <td v-if="decisionItem3.icon">
                                                                <div
                                                                     v-html="decisionItem3.icon"
                                                                     :id="((decisionItem3.code) ? ('TAO_DI3_REC_ICON_' + decisionItem3.code) : null)"
                                                                     class="decision-item-item-svg"
                                                                ></div>
                                                            </td>

                                                            <td>
                                                                <h4 v-bind:style="{'color': getDecisionItemColor(decisionItem3) }"
                                                                    :id="((decisionItem3.code) ? ('TAO_DI3_REC_HEADLINE_' + decisionItem3.code) : null)"
                                                                    v-html="decisionItem3.headline"
                                                                    class="di-headline decision-headline">
                                                                </h4>
                                                                <p v-if="decisionItem3.text"
                                                                   v-html="decisionItem3.text"
                                                                   :id="((decisionItem3.code) ? ('TAO_DI3_REC_TEXT_' + decisionItem3.code) : null)"
                                                                   class="decision-text"
                                                                ></p>
                                                            </td>

                                                        </tr>
                                                    </table>
                                                </div>

                                                <div v-if="scoringPopupData.decisions.decisionItems3Possible.length > 0" class="decision-item-header">
                                                    {{ text('api.assessment.headline.di3.possible') }}
                                                </div>
                                                <div v-for="decisionItem3 in scoringPopupData.decisions.decisionItems3Possible"
                                                     :id="((decisionItem3.code) ? ('TAO_DI3_POS_' + decisionItem3.code) : null)"
                                                     class="padding-left-s"
                                                >
                                                    <table role="presentation">
                                                        <tr>
                                                            <td v-if="decisionItem3.icon">
                                                                <div
                                                                    v-html="decisionItem3.icon"
                                                                    :id="((decisionItem3.code) ? ('TAO_DI3_POS_ICON_' + decisionItem3.code) : null)"
                                                                    class="decision-item-item-svg"
                                                                ></div>
                                                            </td>

                                                            <td>
                                                                <h4 v-bind:style="{'color': getDecisionItemColor(decisionItem3) }"
                                                                    v-html="decisionItem3.headline"
                                                                    :id="((decisionItem3.code) ? ('TAO_DI3_POS_HEADLINE_' + decisionItem3.code) : null)"
                                                                    class="di-headline decision-headline">
                                                                </h4>
                                                                <p v-if="decisionItem3.text"
                                                                   v-html="decisionItem3.text"
                                                                   :id="((decisionItem3.code) ? ('TAO_DI3_POS_TEXT_' + decisionItem3.code) : null)"
                                                                   class="decision-text"
                                                                ></p>
                                                            </td>

                                                        </tr>
                                                    </table>
                                                </div>
                                                <br/>
                                            </div>


                                            <div v-if="scoringPopupData.decisions.decisionItems4 && scoringPopupData.decisions.decisionItems4.length > 0">
                                                <h3 class="headline-decision-h3">{{text('api.assessment.headline.di4')}}</h3>
                                                <div v-if="scoringPopupData.decisions.decisionItems4Recommended.length > 0" class="decision-item-header">
                                                    {{ text('api.assessment.headline.di4.recommended') }}
                                                </div>
                                                <div v-for="decisionItem4 in scoringPopupData.decisions.decisionItems4Recommended"
                                                     :id="((decisionItem4.code) ? ('TAO_DI4_REC_' + decisionItem4.code) : null)"
                                                     class="padding-left-s"
                                                >
                                                    <table role="presentation">
                                                        <tr>
                                                            <td v-if="decisionItem4.icon">
                                                                <div v-html="decisionItem4.icon"
                                                                     :id="((decisionItem4.code) ? ('TAO_DI4_REC_ICON_' + decisionItem4.code) : null)"
                                                                     class="decision-item-item-svg"
                                                                ></div>
                                                            </td>

                                                            <td>
                                                                <h4 v-bind:style="{'color': getDecisionItemColor(decisionItem4)}"
                                                                    v-html="decisionItem4.headline"
                                                                    :id="((decisionItem4.code) ? ('TAO_DI4_REC_HEADLINE_' + decisionItem4.code) : null)"
                                                                    class="di-headline decision-headline"
                                                                ></h4>
                                                                <p v-if="decisionItem4.text"
                                                                   :id="((decisionItem4.code) ? ('TAO_DI4_REC_TEXT_' + decisionItem4.code) : null)"
                                                                   v-html="decisionItem4.text"
                                                                   class="decision-text">
                                                                </p>
                                                            </td>

                                                        </tr>
                                                    </table>
                                                </div>

                                                <div v-if="scoringPopupData.decisions.decisionItems4Possible.length > 0" class="decision-item-header">
                                                    {{ text('api.assessment.headline.di4.possible') }}
                                                </div>
                                                <div v-for="decisionItem4 in scoringPopupData.decisions.decisionItems4Possible"
                                                     :id="((decisionItem4.code) ? ('TAO_DI4_POS_' + decisionItem4.code) : null)"
                                                     class="padding-left-s"
                                                >
                                                    <table role="presentation">
                                                        <tr>
                                                            <td v-if="decisionItem4.icon">
                                                                <div
                                                                    v-html="decisionItem4.icon"
                                                                    :id="((decisionItem4.code) ? ('TAO_DI4_POS_ICON_' + decisionItem4.code) : null)"
                                                                    class="decision-item-item-svg">
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <h4 v-bind:style="{'color': getDecisionItemColor(decisionItem4)}"
                                                                    :id="((decisionItem4.code) ? ('TAO_DI4_POS_HEADLINE_' + decisionItem4.code) : null)"
                                                                    v-html="decisionItem4.headline"
                                                                    class="di-headline decision-headline"
                                                                ></h4>
                                                                <p v-if="decisionItem4.text"
                                                                   :id="((decisionItem4.code) ? ('TAO_DI4_POS_TEXT_' + decisionItem4.code) : null)"
                                                                   v-html="decisionItem4.text"
                                                                   class="decision-text"
                                                                ></p>
                                                            </td>

                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>

                                        </td>
                                    </tr>
                                </table>

                            </div>

                            <div v-if="scoringPopupData.comments.commentTexts.length > 0" class="margin-bottom-m">
                                <br />
                                <h3>{{text('db.product.PROD_TITLE_RAT')}}</h3>
                                <div>
                                    <div>
                                        <p v-for="comment in scoringPopupData.comments.commentTexts" v-html="comment">
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div v-if="Object.keys(scoringPopupData.displayedCodeSystems).length > 0">
                                <div >
                                    <h3>{{text("api.summary.communication.codeSystem")}}</h3>
                                </div>
                                <div>
                                    <div v-for="(codeSystem, key) in scoringPopupData.displayedCodeSystems"
                                         :id="((codeSystem.type) ? ('TAO_CODE_SYSTEM_' + codeSystem.type) : null)"
                                         class="margin-bottom-s"
                                    >
                                        <h4 v-if="codeSystem.name !== 'undefined' &&
                                                      codeSystem.name !== null &&
                                                      codeSystem.name.length > 0"
                                            :id="((codeSystem.type) ? ('TAO_CODE_SYSTEM_NAME_' + codeSystem.type) : null)"
                                        >
                                                {{codeSystem.name}}
                                        </h4>
                                        <ul v-for="code in codeSystem.articles" class="code-system">
                                            <li :id="((code.code) ? ('TAO_CODE_ARTICLE_' + code.code) : null)">{{code.code}} - {{code.name}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </v-card-text>
                    <v-card-actions class="elevation-bg-color">
                        <v-spacer></v-spacer>
                        <v-btn @click="navGotoScoringPage()" id="btnTaoPopupFinish" class="btn-evaluation bg-color-primary-important" >{{text('api.button.finish')}}</v-btn>
                        <v-btn @click="hideScoringPopup()" id="btnTaoPopupCancel" class="hide-scoring-popup" >{{ text('api.button.cancel') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapActions, mapGetters} from 'vuex';
import CloseIcon from "../svg/shared/closeIcon";
import WarningIcon from "../svg/shared/warningIcon.vue";

export default {
        name: 'ScoringPopup',
    components: {WarningIcon, CloseIcon},
    computed: {
            ...mapGetters({
                scoringPopupData: 'AssessmentAlertsStore/getScoringPopupData',
                mustShowScoringPopup: 'AssessmentAlertsStore/getMustShowScoringPopup',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getDecisionItemColor: 'ThemeStore/getDecisionItemColor'
            }),
            dialogMaxWidth() {
                if (this.$vuetify.breakpoint.width > 650) {
                    return '70%';
                }
                return '550px'
            }
        },

        mounted() {

            /* close the popup on outside click*/
            document.addEventListener("click", (evt) => {
                const flyoutElement = document.getElementById("close-popup");
                let targetElement = evt.target; // clicked element

                do {
                    if (targetElement == flyoutElement) {
                        // This is a click inside. Do nothing, just return.
                        console.log("click inside");
                       // return;
                    }
                    // Go up the DOM
                    targetElement = targetElement.parentNode;
                } while (targetElement);

                this.hideScoringPopup();

            });
        },

        methods: {
            ...mapActions({
                showScoringPopup: 'AssessmentAlertsStore/showScoringPopup'
            }),

            hideScoringPopup() {
                this.$store.commit('AssessmentAlertsStore/setMustShowScoringPopup', false);
            },

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/

            handleKeyDowns(evt) {

                switch (evt.keyCode) {

                    // Tab
                    case 9:
                        evt.preventDefault();
                        evt.stopPropagation();
                        evt.stopImmediatePropagation();
                        return false;
                }

                if (this.mustShowScoringPopup === false) {
                    return;
                }

                switch (evt.keyCode) {

                    // Backspace
                    case 8:
                        evt.preventDefault();
                        evt.stopPropagation();
                        evt.stopImmediatePropagation();
                        return false

                    // Escape => (Cancel button)
                    case 27:
                        this.hideScoringPopup();
                        break;

                    // Page Up
                    case 33:
                        if (this.$refs["vCardPopupScoring"] != null) {
                            this.$refs["vCardPopupScoring"].scrollTop -= 10;
                        }
                        break;

                    // Page Down
                    case 34:
                        if (this.$refs["vCardPopupScoring"] != null) {
                            this.$refs["vCardPopupScoring"].scrollTop += 10;
                        }
                        break;

                    //End
                    case 35:
                        // Shift + End => go to scoring page (Finish button)
                        evt.preventDefault();
                        if (evt.shiftKey === true && evt.altKey === false && evt.ctrlKey === false) {
                            this.navGotoScoringPage();
                        }
                        break;

                    // M
                    case 77:
                        // ALT + M
                        if (evt.shiftKey === false && evt.altKey === true && evt.ctrlKey === false) {
                            // focus on textarea comment
                            evt.preventDefault();
                            this.hideScoringPopup();
                        }
                        break;

                }

            },

            handleKeyUps(evt) {

                switch (evt.keyCode) {

                    // Tab
                    case 9:
                        evt.preventDefault();
                        evt.stopPropagation();
                        evt.stopImmediatePropagation();
                        return false;

                }
            },

            navGoToEvaluation() {
                this.hideScoringPopup();
                this.$router.push('/evaluation');
            },

            navGotoScoringPage(){
                let promiseEvaluateAssessment = this.$store.dispatch('EvaluationStore/evaluateAssessment', {
                    shortcutUsed: true
                });
                promiseEvaluateAssessment.then(() => {
                    this.$store.commit('ScoringStore/clearTestTreeData');
                    this.$store.commit('AssessmentAlertsStore/setMustShowScoringPopup', false);

                    this.$router.push('/scoring');
                });
                promiseEvaluateAssessment.catch(() => {
                    // @TODO This alert with static text is just a quick solution until we decide what to display to the user when the request wasn't successfully done. Need to replace alert() with something else and the text must use translation mechanism.
                    alert("Couldn't evaluate assessment. Please try again.");
                });
            }

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***        END CODE         ***
             *******************************/
        },

        created: function() {
            document.addEventListener('keydown', this.handleKeyDowns);
            document.addEventListener('keyup', this.handleKeyUps);
        },

        destroyed: function() {
            document.removeEventListener('keydown', this.handleKeyDowns);
            document.removeEventListener('keyup', this.handleKeyUps);
        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .assessment-content-table tr td:nth-child(2) {
        padding-left: 5px;
    }

    .assessment-content-table td {
        vertical-align: top !important;
    }

  .code-system li {
      font-weight: $font-weight-regular;
      list-style-type: disc !important;
      margin-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/shared/ScoringPopup.vue